var map = {
	"./Components/Entries/entries.module": [
		"./src/app/Components/Entries/entries.module.ts"
	],
	"./Components/Tabs/tabs.module": [
		"./src/app/Components/Tabs/tabs.module.ts",
		"default~Components-Tabs-tabs-module~entries-data-entries-data-module",
		"Components-Tabs-tabs-module"
	],
	"./Components/login/login.module": [
		"./src/app/Components/login/login.module.ts",
		"Components-login-login-module"
	],
	"./Components/otp/otp.module": [
		"./src/app/Components/otp/otp.module.ts",
		"Components-otp-otp-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/Components/Entries/dashboard/dashboard.module.ts",
		"dashboard-dashboard-module"
	],
	"./entries-data/entries-data.module": [
		"./src/app/Components/Entries/entries-data/entries-data.module.ts",
		"default~Components-Tabs-tabs-module~entries-data-entries-data-module",
		"entries-data-entries-data-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;